import {useMutation, useQueryClient} from 'react-query'
import {BunkerRequest} from "../../../types";
import {showNotification} from "@mantine/notifications";
import {Check} from "tabler-icons-react";

const onMutateSuccess = (values: BunkerRequest) => {
    showNotification({
        title: 'Notification deleted',
        icon: <Check/>,
        message: `Notification has been deleted!`,
    })
}

const onMutateError = (error: string) => {
    showNotification({
        title: `Something went wrong`,
        message: `An error occurred while deleting the notification. ${error}`,
        color: 'red'
    })
}

export default function useMutateNotificationData(mutationFn: (args: any) => Promise<unknown>, onSuccess: any = onMutateSuccess, onError: any = onMutateError) {
    const queryClient = useQueryClient();
    return useMutation(mutationFn, {
        onSuccess: (data) => {
            // Reload bunkerRequest data
            queryClient.invalidateQueries(['notifications']);

            onSuccess?.(data)
        },
        onError: (data) => onError?.(data)
    });
}
